<script setup lang="ts">
    import UserCollection from '~~/app/auth/collections/UserCollection';
    import User from '~~/app/auth/models/User';
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';

    interface Props extends FormInputProps {
        closeOnSelect?: boolean;
        multiple?: boolean;
        formKey?: string;
        chipMode?: boolean;
    }
    const props = withDefaults(defineProps<Props>(), {
        closeOnSelect: true,
        multiple: false,
        formKey: 'user',
        chipMode: false,
    });
    const inputData: FormInputData = useFormInput(props);

    const select = ref(null);
    const setValue = (value: User | Array<User>) => {
        inputData.form.set(props.formKey, value);
    };

    const removeUser = (user: User) => {
        const currentUsers = inputData.form.get(props.formKey);
        if (Array.isArray(currentUsers)) {
            const filtered = currentUsers.filter((u: User) => u.getId() !== user.getId());
            const newValue = filtered.length > 0 ? filtered : null;
            inputData.form.set(props.formKey, newValue);
            select.value?.setValue(newValue || []);
        }
    };
</script>

<template>
    <FormElement
        :input-data="inputData"
        @label-clicked="select?.show()"
    >
        <SelectUser
            ref="select"
            :initial-value="inputData.model.value"
            :close-on-select="closeOnSelect"
            :multiple="multiple"
            @selected="setValue"
        >
            <template
                v-if="chipMode && multiple"
                #selected="{ selected }"
            >
                <div class="flex flex-wrap gap-2">
                    <div
                        v-for="user in (Array.isArray(selected) ? selected : [selected])"
                        :key="user.getId()"
                        class="flex items-center px-2 py-1 space-x-2 text-sm rounded-md border shadow-[0px_1px_2px_0px_rgba(0,0,0,0.1)] bg-white transition-all"
                    >
                        <AuthUserAvatar
                            :user="user"
                            size="w-5 h-5"
                            :clickable-avatar="false"
                        />
                        <span class="text-sm text-branding-rich-black">{{ user.displayName }}</span>
                        <button
                            type="button"
                            class="text-gray-400 hover:text-gray-600"
                            @click.prevent.stop="removeUser(user)"
                        >
                            <i class="fa-solid fa-xmark text-xs"></i>
                        </button>
                    </div>
                </div>
            </template>
        </SelectUser>
    </FormElement>
</template>
